<template>
  <div class="page">
    <div class="page-bd max">
      <div class="content">
        <!-- <Card class="card" :padding="0">
          <div slot="title" class="home_title">
            <span class="title_left">{{ $t('home.school') }}</span>
            <a class="title_right" @click="handelAdd()">{{ $t('home.add_school_user') }}</a>
          </div>
          <div v-for="(item, i) in schoolList" :key="'school'+i" class="item df_between">
            <div>
              <div>{{ item.name }}</div>
              <div>{{ $t('home.school_new_apply') }}</div>
            </div>
            <div>
              <a class="check" @click="handelLinkTo(item,'school')">{{ $t('home.check') }}</a>
            </div>
          </div>
        </Card>
        <Card class="card" :padding="0">
          <div slot="title" class="home_title">
            <span class="title_left">{{ $t('home.teacher') }}</span>
            <a class="title_right">{{ $t('home.add_teacherl_user') }}</a>
          </div>
          <div v-for="(item, i) in teacherList" :key="'school'+i" class="item df_between">
            <div>
              <div>{{ item.name }}</div>
              <div>{{ $t('home.teacher_new_apply') }}</div>
            </div>
            <div>
              <a class="check" @click="handelLinkTo(item,'teacher')">{{ $t('home.check') }}</a>
            </div>
          </div>
        </Card>-->
        <Row :gutter="15">
          <Col span="12" v-for="(item,index) in  list" :key="index">
            <Card class="mg-bottom15">
              <div class="cardList">
                <h2 class="mg-bottom15">{{item.title}}</h2>
                <div class="mg-bottom5">
                  <span class="tit mg-right10">{{$t('amount')}}</span>
                  <span class="num">{{item.count}}</span>
                </div>
                <div>
                  <span class="tit mg-right10">{{$t('activate')}}</span>
                  <span class="num">{{item.active_count}}</span>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      schoolList: [
        { name: 'BBC School' }, { name: 'AAC School' }, { name: 'asdf School' },
      ],
      teacherList: [
        { name: 'Benny' }, { name: 'Lily' }, { name: 'cherry' },
      ],
      list: [
        {
          title: this.$t('home.school_count'),
          count: "",
          active_count: "",
        },
        {
          title: this.$t('home.teacher_count'),
          count: "",
          active_count: "",
        },
        {
          title: this.$t('home.faculty_count'),
          count: "",
          active_count: "",
        },
        {
          title: this.$t('home.job_count'),
          count: "",
          active_count: "",
        }
      ]

    }
  },
  mounted: function () {
    this.getBeforeList()
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading();
      this.$request.sendPost(
        "com/get-index-data",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.list = [
            {
              title: this.$t('home.school_count'),
              count: data.school_count,
              active_count: data.school_active_count,
            },
            {
              title: this.$t('home.teacher_count'),
              count: data.teacher_count,
              active_count: data.teacher_active_count,
            },
            {
              title: this.$t('home.faculty_count'),
              count: data.faculty_count,
              active_count: data.faculty_active_count,
            },
            {
              title: this.$t('home.job_count'),
              count: data.job_count,
              active_count: data.job_active_count,
            }
          ]
        }
      );
    },
    handelLinkTo: function (item, type) {
      if (type == 'school') {
        this.$base.linkTo("/school/record");
      }
    },
    handelAdd: function () {

    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .content {
  padding: 0 10px;
  margin-top: 30px;
  .ivu-card {
    border-radius: 6px;
  }
  .cardList {
    padding: 40px 30px 40px 50px;
    .tit {
      font-weight: bold;
      font-size: 16px;
    }
    .num {
      font-weight: 500;
    }
  }
}

.card {
  flex: 1;
  margin: 0 20px;
  border: 1px solid #979797;
  border-radius: 12px;
  padding-bottom: 20px;
}
.home_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title_left {
  font-size: 24px;
  font-weight: 600;
}
.title_right {
  font-size: 14px;
}
.item {
  border-top: 1px solid #e8eaec;
  padding: 10px;
}
.check {
  font-size: 14px;
  color: var(--green_one);
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome/index.vue